import api from "./api";

const findNewsPaginated = (a: any, params: any) => api.get('api/news', {params});


export {findNewsPaginated}
